module.exports = __webpack_public_path__ + "static/media/pm_testimonial_icon.2ce14b34.svg";